import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Portfolio } from "@/components/site/Portfolio";
import { Monferrato } from "@/components/site/Monferrato";
import { Manifesto } from "@/components/site/Manifesto";
import { Contact } from "@/components/site/Contact";
import { scrollToSection } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";
import { useT } from "@/i18n";

export default function HomePage() {
  const { state } = useLocation();
  const t = useT();

  useEffect(() => {
    if (state?.scrollTo) {
      const timer = setTimeout(() => scrollToSection(state.scrollTo), 400);
      return () => clearTimeout(timer);
    }
  }, [state]);

  return (
    <main>
      <Seo title={t.seo.homeTitle} description={t.seo.homeDesc} locale={t.seo.locale} />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <Monferrato />
      <Manifesto />
      <Contact />
    </main>
  );
}
